import { initPostHog } from './utils/posthog'
import { initTippy } from './utils/tippy'

// stick HTMX on the window for access by the pages
import htmx from 'htmx.org'
;(window as any).htmx = htmx

export function initPage(username: string | null = null) {
  if (username) {
    initPostHog(username)
  } else {
    initPostHog()
  }

  initTippy()
}
;(window as any).initPage = initPage
